import moment from 'moment';
import dateFormats from '@/core/constants/DateFormats';

export default {
  data() {
    return {
      minDateRaw: '2026-04-01',
      minDate: new Date(2026, 3, 1), // Month 3 = April
    };
  },

  methods: {
    getValidStartDate() {
      const minDate = moment(this.minDateRaw);
      const thirtyDaysAgo = moment().subtract(30, 'days');

      return moment.max(minDate, thirtyDaysAgo).format(dateFormats.ISO_DATE);
    },
  },

  computed: {
    minDateYear() {
      return moment(this.minDate).year();
    },

    minDateMonthNumber() {
      return moment(this.minDate).month() + 1;
    },

    minDateReadable() {
      return moment(this.minDate)
        .locale('es')
        .format(dateFormats.MONTH_YEAR_WITH_PREPOSITION);
    },
  },
};
